import { getContentApiBaseUrl } from '../../helpers/contentApi.helper';

import { useAuthSession } from '../useAuthSession';

/**
 * Content API base URL for the signed-in customer's region
 */
const useContentApiBaseUrl = (): string => {
    const { user } = useAuthSession();

    return getContentApiBaseUrl(user?.contentApiRegion);
};

export default useContentApiBaseUrl;
